import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
});

// Request interceptor for adding auth token
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
    }
    return Promise.reject(error);
  }
);

// Upload helper function for file uploads
export const uploadImage = async (file, folder = 'tours') => {
  const formData = new FormData();
  formData.append('image', file);

  const token = localStorage.getItem('token');
  const config = {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` })
    }
  };

  const response = await API.post(`/upload?folder=${folder}`, formData, config);
  return response.data;
};

export default API;